/** Logo file in `public/` — do not hotlink external sites. */
export const BRAND_LOGO_FILENAME = 'COLLIER_TRAINING_SOLUTIONS_LTD_LOGO_RGB-01.png' as const;

/** Default public-facing brand (Ireland T&T). Use for emails, PDFs, and UI fallbacks. */
export const BRAND = {
  name: 'Ireland T&T',
  email: 'info@irelandtt.com',
  website: 'www.irelandtt.com',
  websiteHost: 'irelandtt.com',
  phonePrimary: '+353 1 460 4829',
  phoneMobile: '+353 870 930 808',
  phoneDisplay: '+353 1 460 4829 | +353 870 930 808',
  addressLine1: '11C Parkmore Industrial Estate, Dublin 12',
  /** Same-origin path (Vite `public/`). Place `BRAND_LOGO_FILENAME` in `public/images/`. */
  logoUrl: `/images/${BRAND_LOGO_FILENAME}` as const,
  /** Customer record search (locations default) — match company_name in DB */
  customerNameSearchPattern: '%ireland%',
} as const;

/**
 * Absolute URL for `<img src>` in outbound HTML emails (many clients ignore relative URLs).
 * Set `VITE_PUBLIC_APP_URL` to your deployed origin (no trailing slash).
 */
export function brandLogoUrlForEmail(): string {
  const base = (import.meta.env.VITE_PUBLIC_APP_URL as string | undefined)?.replace(/\/$/, '') ?? '';
  return base ? `${base}${BRAND.logoUrl}` : BRAND.logoUrl;
}
